import { FormControl, InputLabel, Select, TextField, makeStyles } from '@material-ui/core';

import {
  ARCHIVABLE_STATUS_FILTERS,
  ARCHIVABLE_STATUS_FILTER_LABELS,
  ArchivableStatusFilter,
} from '../../../shared/constants/entity-status-filter.constants';

const SEARCH_INPUT_ID = 'delivery-zones-search';
const STATUS_FILTER_INPUT_ID = 'delivery-zones-status-filter';

interface DeliveryZonesListFiltersProps {
  search: string;
  statusFilter: ArchivableStatusFilter;
  onSearchChange: (value: string) => void;
  onStatusFilterChange: (value: ArchivableStatusFilter) => void;
}

const useStyles = makeStyles({
  filters: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '1rem',
  },
});

export function DeliveryZonesListFilters({
  search,
  statusFilter,
  onSearchChange,
  onStatusFilterChange,
}: DeliveryZonesListFiltersProps) {
  const classes = useStyles();

  return (
    <section className={classes.filters}>
      <TextField
        id={SEARCH_INPUT_ID}
        size="small"
        label="Rechercher"
        type="text"
        variant="outlined"
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
      />
      <FormControl variant="outlined" size="small">
        <InputLabel htmlFor={STATUS_FILTER_INPUT_ID}>Statut</InputLabel>
        <Select
          native
          label="Statut"
          value={statusFilter}
          inputProps={{ id: STATUS_FILTER_INPUT_ID }}
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
            onStatusFilterChange(event.target.value as ArchivableStatusFilter)
          }
        >
          {ARCHIVABLE_STATUS_FILTERS.map((status) => (
            <option key={status} value={status}>
              {ARCHIVABLE_STATUS_FILTER_LABELS[status]}
            </option>
          ))}
        </Select>
      </FormControl>
    </section>
  );
}
